import { SurveyV2 } from '@act/shared/data-transfer-objects';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Control } from 'react-hook-form';

export interface CheckboxInputProps {
  control: Control<{ [key: string]: number }>;
  options: SurveyV2.CreateOptionJSONDto[];
  isRequired: boolean;
}

const CheckboxInput = ({ options, isRequired }: CheckboxInputProps) => {
  return (
    <FormGroup>
      {options.map(option => {
        return (
          <FormControlLabel
            key={option.sortOrder}
            control={
              <Checkbox
                id={option.sortOrder.toString()}
                value={option.sortOrder.toString()}
              />
            }
            label={option.text}
            required={isRequired}
          />
        );
      })}
    </FormGroup>
  );
};

export default CheckboxInput;
